import { useState } from 'react'

type UsePhoneValuesProps = {
  initialPhoneNumber?: string
  initialWhatsappNumber?: string
  initialWhatsappSameAsPhone?: boolean
}

export function usePhoneValues(props: UsePhoneValuesProps) {
  const { initialPhoneNumber, initialWhatsappNumber, initialWhatsappSameAsPhone } = props

  const [phone, setPhone] = useState<string | undefined>(initialPhoneNumber)
  const [whatsapp, setWhatsapp] = useState<string | undefined>(initialWhatsappNumber)
  const [whatsappSameAsPhone, setWhatsappSameAsPhone] = useState(initialWhatsappSameAsPhone)

  const onPhoneChange = (value: string | undefined) => {
    setPhone(value)
    if (whatsappSameAsPhone) {
      setWhatsapp(value)
    }
  }

  const onWhatsappChange = (value: string | undefined) => {
    if (!whatsappSameAsPhone) {
      setWhatsapp(value ?? '')
    }
  }

  const onWhatsappSameAsPhoneCheckboxChange = (checked: boolean) => {
    setWhatsappSameAsPhone(checked)
    if (checked) {
      setWhatsapp(phone)
    }
  }

  return {
    phone,
    whatsapp,
    whatsappSameAsPhone,
    onPhoneChange,
    onWhatsappChange,
    onWhatsappSameAsPhoneCheckboxChange,
  }
}
